module.exports = __webpack_public_path__ + "static/lock-7e2fa6a76a54114bbcb787d4e5ffc25e.svg";